<template>
  <div style="overflow-x: hidden;">
    <ImageWall :url="imgUrl('img-wall-about.jpg')" />
    <v-container class="aboutUsPage pt-0">
      <div class="wrapperWidth pb-10 mb-8">
        <icon
          name="golf-sticks"
          width="214"
          height="236"
          class="absolute golfStick"
        />
        <icon name="golf" width="168" height="261" class="absolute golf hidden-md-and-down" />
        <v-row no-gutters justify="space-between" class="px-5 px-md-16 displayScreen">
          <div
            class="font-weight-bold text-md-h2 text-h4 mt-md-12 mt-8 black--text align-self-end capitalizeText"
            v-translate
          >
            about
          </div>
          <AvatarComponent
            :size="$vuetify.breakpoint.xsOnly ? '200' : '290'"
            :class="$vuetify.breakpoint.smAndDown ? 'text-center' : ''"
            class="avatarMask"
            hasBorder
            :url="imgUrl('avatar-main.jpg')"
          />
        </v-row>
        <v-row
          no-gutters
          class="black--text mt-4 mt-md-10 px-4 px-md-16 text-justify"
        >
          <p v-translate>
            Hi, my name is Florian. I’m a business guy in the tech field based out of Ho Chi Minh City who turned my start-up into a going concern. As a bachelor with no kids, a good income and plenty of time on my hands, I had the perfect life.
          </p>
          <p v-translate>Until I ruined it by taking up golf!</p>
          <p v-translate>
            If you’re a golfer yourself, you know what I’m talking about. Developing your swing is hard, making clean shots is hard, avoiding hazards is hard, getting a good bounce is hard… it’s all hard. And I LOVE every last frustrating thing about it!
          </p>
          <p v-translate>
            Except one thing. You know that feeling you get when you play a course once and it’s awesome, then you play it a few more times and, well, you start looking for a new challenge… Let’s face it, people love discovering new things and golfers are no exception.
          </p>
          <p v-translate>
            Now here’s the thing. Finding courses that are fresh and exciting isn't easy, and once you do, do you play as a Singleton? Finding suitable golf partners on a course some distance from where you live – folks with similar attitudes to the game and skill levels – was a real problem. More frustration!
          </p>
          <p v-translate>
            Good thing there’s nothing a guy in tech field like me loves more than a problem!
          </p>
        </v-row>
        <v-row no-gutters class="paddingCustomRow mt-md-5 pr-sm-0 pr-md-16">
          <v-col cols="12" :sm="5">
            <v-card class="pa-4 mb-3" :class="$vuetify.breakpoint.smAndDown ? 'shadow-none' : ''" style="box-shadow: 0px 0px 8px rgb(0 0 0 / 25%) !important;">
              <v-image
                :src="imgUrl('avatar-flo.jpg')"
                :width="$vuetify.breakpoint.sm ? '390' : '100%'"
                :height="$vuetify.breakpoint.sm ? '470' : 'auto'"
              />
            </v-card>
          </v-col>
          <v-col
            cols="12"
            :sm="7"
            class="black--text pl-md-5 pr-md-0 px-4 text-justify"
          >
          <div class="mb-4">
            <span v-translate>So, I founded BGC (Best Golf Course). BGC is an online golfer community that’s constantly supplied with fresh information from a variety of sources like Google, Facebook, TripAdvisor, Instagram, Twitter, respected golf Vloggers, Pros, etc… All curated by our </span>
            <MyTooltip :text="$gettext('Golf Course Ranking algorithm')" />
            <span v-translate>. That helps you find the very best golf courses according to people who’ve actually played them anywhere in the world!</span>
          </div>
            <p v-translate>
              Once you’ve decided on a course, our advanced Player Finder algorithm helps you connect with golfers to play with locally, so you don’t have to go it alone. Finally, BGC logs everything that happens on every hole to keep your stats up to date.
            </p>
            <p v-translate>
              BGC has a lot to offer, and it neatly solves the problem of finding where to play and who to play with when you need a bit of a change from your home course.
            </p>
            <p v-translate>If you want to contact me</p>
            <v-row no-gutters justify="space-between" class="align-end pr-md-8">
              <a href="https://www.facebook.com/florian.berta" target="_blank">
                <v-icon :size="$vuetify.breakpoint.smAndUp ? '40' : '30'" color="#2F80ED" class="mx-2"
                >fab fa-facebook-f</v-icon>
              </a>
              <a href="https://www.instagram.com/florian_golf_travel" target="_blank">
                <v-icon :size="$vuetify.breakpoint.smAndUp ? '40' : '30'" color="#BB6BD9" class="mx-2"
                  >fab fa-instagram</v-icon
                >
              </a>
              <a href="https://www.youtube.com/channel/UChW9g08sLpitNqEanWo7ZHw" target="_blank">
                <v-icon :size="$vuetify.breakpoint.smAndUp ? '40' : '30'" color="#EB5757" class="mx-2"
                  >fab fa-youtube</v-icon
                >
              </a>
              <a href="https://bestgolfcourse.org/profiles/56" target="_blank">
                <span class="d-flex">
                  <icon
                    name="icon-logo"
                    :width="$vuetify.breakpoint.smAndUp ? '100' : '60'"
                    :height="$vuetify.breakpoint.smAndUp ? '42' : '25'"

                  />
                </span>
              </a>
              <router-link :to="{name: 'contact'}">
                <v-icon :size="$vuetify.breakpoint.smAndUp ? '40' : '30'" color="#F2994A" class="mx-2"
                >far fa-envelope</v-icon>
              </router-link>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import ImageWall from "@/components/ImageWall";
import MyTooltip from "@/components/Dialog/MyTooltip";
export default {
  name: "AboutUs",
  components: { ImageWall, MyTooltip },
};
</script>
